import React from "react";
import styled from "styled-components";

const Card = styled.a`
  width: 300px;
  min-height: 350px;
  background-color: #f8f9fa;
  border-radius: 15px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-decoration: none;
  color: inherit;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
`;

const Image = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 10px;
`;

const Title = styled.h3`
  font-family: "Playfair Display", serif;
  font-size: 24px;
  font-weight: 500;
  color: #333333;
  margin: 20px 0 10px;
`;

const Description = styled.p`
  font-family: Arial, sans-serif;
  font-size: 16px;
  color: #555;
  line-height: 1.5;
  flex-grow: 1;
`;

function ProjectCard({ title, image, description, demoLink }) {
  return (
    <Card
      href={demoLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      {image && (
        <Image
          src={image}
          alt={title}
        />
      )}

      <Title>{title}</Title>

      <Description>{description}</Description>
    </Card>
  );
}

export default ProjectCard;